<div class="container">

<div [innerHTML]="textFemaTraining" style="padding-left: 10px; padding-top: 20px;"></div>

<ebb-training [trainingType]="trainingType" [currentUser]="currentUser"></ebb-training>
</div>

